import React, { FC } from 'react'
import { connect } from 'react-redux'
import { formValueSelector, change, registerField } from 'redux-form'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { accountViewBalance } from 'src/store/account'
import AccountSelectModal, { open as OpenAccountSearchModal } from '../../AccountSearch/AccountSelectModal'
import { SearchAccountsButtonProps, AccountData } from './components.types'

const SearchAccountsButton: FC<SearchAccountsButtonProps> = ({
  CCY,
  AccNo,
  innerRef,
  OpenAccountSearch,
  chooseAccount,
  modalName,
  disabled,
  page,
}) => (
  <>
    <LKButton innerRef={innerRef} alias="ellipsis" onClick={OpenAccountSearch} disabled={disabled} />
    <AccountSelectModal name={modalName} ccy={CCY} accNo={AccNo} page={page} onSelect={chooseAccount} />
  </>
)

export default connect(
  //@ts-ignore
  (state, { FormName, ccyName = 'CCY', accNo, chosenAccNo }) => {
    const valueSelector = formValueSelector(FormName)

    const AccNo = valueSelector(state, accNo)
    const ChoseAccNo = valueSelector(state, chosenAccNo)

    return { CCY: valueSelector(state, ccyName), AccNo: AccNo === ChoseAccNo ? undefined : AccNo }
  },
  //@ts-ignore
  (dispatch, { FormName, accNo, titleUNI, accID, accHash, chosenAccNo, accBalance, modalName }) => ({
    OpenAccountSearch: () => dispatch(OpenAccountSearchModal({ name: modalName })),

    chooseAccount: (data: AccountData) => {
      dispatch(change(FormName, accID, data.ID))
      dispatch(change(FormName, accHash, data.HashSum_AccountID_))
      dispatch(change(FormName, chosenAccNo, data.AccNo))
      dispatch(change(FormName, 'chosenAccountTypeID', parseInt(data.TypeID.toString(), 10))) // to check if money transfer section is visible

      if (data.TypeID === 9) {
        dispatch(registerField(FormName, 'MoneyTransferCountryID', 'Field'))
        dispatch(registerField(FormName, 'MoneyTransferSystemID', 'Field'))
        dispatch(registerField(FormName, 'MoneyTransferCode', 'Field'))
        dispatch(registerField(FormName, 'MoneyTransferAgent', 'Field'))
      }

      Promise.resolve(
        dispatch(
          //@ts-ignore
          accountViewBalance({
            AccountID: data.ID,
            HashSum_AccountID_: data.HashSum_AccountID_,
          }),
        ),
      )
        //@ts-ignore
        .then(({ payload }) => {
          if (payload) {
            dispatch(change(FormName, accNo, parseInt(data.AccNo, 10)))
            dispatch(change(FormName, titleUNI, data.TitleUNI))
            dispatch(change(FormName, accBalance, payload.Balance))
          }
        })
        .catch((error) => console.error(error))
    },
  }),
)(SearchAccountsButton)
